// extracted by mini-css-extract-plugin
export default {"container_modal":"ModalApps_container_modal__uzTnO","container_caminhos":"ModalApps_container_caminhos__7DHih"};